module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/weather/sun-fog-4c880123435768c3feeaf494f345b74b.svg";